import { Tabs } from "antd"
import { getTranslated } from "../../utils/CommonUtils"
import { useSelector } from "react-redux"
import { useState } from "react"
import WhatsNewInfo from './WhatsNewInfo'
import FeatureList from "./FeatureList"

const WhatsNewData = () => {

    const dict = useSelector((state) => state.common.dict)
    const [selectedTab, setSelectedTab] = useState("Whats New with UMC")


    const items = [
        {
            key: 'Whats New with UMC',
            label: getTranslated(dict, "LABEL_WHATS_NEW"),
            children: <WhatsNewInfo />
        },
        {
            key: 'Features List',
            label: getTranslated(dict, "LABEL_FEATURES_LIST"),
            children: <FeatureList />
        },
    ]

    const onChange = (key) => {
        setSelectedTab(key)
    }

    return <Tabs
        defaultActiveKey="Whats New with UMC"
        type="card"
        className="tab-common"
        activeKey={selectedTab}
        items={items}
        onChange={(key) => (key !== selectedTab) && onChange(key)}
        animated={{ inkBar: true, tabPane: true }}
    />
}

export default WhatsNewData